module.exports = __webpack_public_path__ + "img/icon_live_attendance@2x.c80e929d.png";